import React, { useMemo, useState } from 'react'
import Button from 'components/Button'
import Dropdown from 'components/Dropdown'
import strings from 'strings/en.json'
import '../stylesheets/SelectPTP.scss'
import ParticipantSelectionOverlay from 'components/ParticipantSelectionOverlay'
import { CAREGIVER_ASSIGNMENT_OVERLAY_TITLE } from 'utils/constants'
import { navigateTo } from 'navigation'

const SelectPTPPage = ({ isCaregiver, participants, selected, setSelected }) => {
    if (!isCaregiver) return null

    if (!participants || participants.length === 0) {
        return (
            <div className='container select-ptp-page'>
                <ParticipantSelectionOverlay
                    title={CAREGIVER_ASSIGNMENT_OVERLAY_TITLE}
                    message={strings.caregiver_no_assignment}
                />
            </div>
        )
    }

    const options = useMemo(
        () => [
            { key: '', value: '', text: '' }, // empty default option
            ...participants
                .map(p => ({ key: String(p.id), value: String(p.id), text: p?.subject_id || p?.id }))
                .sort((a, b) => String(a.text).localeCompare(String(b.text)))
        ],
        [participants]
    )

    const [localSelection, setLocalSelection] = useState(selected ? String(selected.id) : '')
    const onConfirm = () => {
        if (!localSelection) return
        const chosen = participants.find(p => String(p.id) === String(localSelection))
        if (chosen) {
            setSelected(chosen)
            // Navigate back to activities
            navigateTo('/my-activities')
        }
    }

    return (
        <div className='container select-ptp-page'>
            <div className='select-ptp-wrapper'>
                <h4 className='select-ptp-title'>{strings.caregiver_switcher_title}</h4>
                <div className='select-ptp-card'>
                    <p className='select-ptp-help'>
                        {strings.caregiver_switcher_description}
                    </p>
                    <div className='select-ptp-field'>
                        <label className='select-ptp-label'>{strings.subject_id}</label>
                        <Dropdown
                            options={options}
                            selected={localSelection}
                            onSelect={item => setLocalSelection(item.value)}
                            main={undefined}
                        />
                    </div>
                    <div className='select-ptp-actions'>
                        <Button content='Confirm' onClick={onConfirm} disabled={!localSelection} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SelectPTPPage


